export enum UserStatusEnum {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED',
	NOT_VERIFIED = 'NOT_VERIFIED',
}
